export default function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/order/none.js
// module id = ./node_modules/d3-shape/src/order/none.js
// module chunks = 1